export function externalInvoiceNotice(order) {
  const invoice = order.externalInvoice ?? order.external_invoice;
  if (!invoice) return null;
  const number = String(invoice.number || '').trim();
  const status = String(invoice.status || '').trim();
  if (!number && ['', '0', '1'].includes(status)) return null;
  const receipt = order.receipt;
  const localNumber = receipt?.receiptNumber ?? receipt?.receipt_number;
  if (receipt && receipt.draft === false && number && number === localNumber) return null;
  return {number, different: Boolean(receipt?.id)};
}
